import arraySort from 'array-sort';

export function filterMetaTagsByCategory(metaTags) {
  if (!metaTags) return [];
  const categorySortOrder = ['main', 'game', 'eventInfo', 'video', 'general', 'photo', 'rights', 'assetDetail'];
  const metaTagsByCategory = [
    ...metaTags
      .reduce(
        (
          result,
          {
            category,
            _id,
            tagName,
            displayName,
            dataType,
            editSortOrder,
            isEditable,
            lookupObjectId,
          },
        ) => {
          result.has(category)
            || result.set(category, {
              category,
              categorySortOrder: categorySortOrder.indexOf(category),
              tags: [],
            });

          result.get(category).tags.push({
            _id,
            tagName,
            displayName,
            dataType,
            editSortOrder,
            isEditable,
            lookupObjectId,
          });
          return result;
        },
        new Map(),
      )
      .values(),
  ];

  metaTagsByCategory.forEach((category) => arraySort(category.tags, 'editSortOrder'));
  return arraySort(metaTagsByCategory, 'categorySortOrder');
}
